import { withExtTenantIdRequest } from '@/utils/request';

// 商家PC端-专属客服二维码
export function getMyCustomerService() {
  return withExtTenantIdRequest({
    url: '/soyoungzg/api/customerService/getMyCustomerService',
    method: 'get',
  });
}
